import { render } from "./ShowMsg.vue?vue&type=template&id=230914c2&scoped=true"
import script from "./ShowMsg.vue?vue&type=script&lang=js"
export * from "./ShowMsg.vue?vue&type=script&lang=js"

import "./ShowMsg.vue?vue&type=style&index=0&id=230914c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-230914c2"

export default script